/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class GmaoViewHeaderController {
    /** @ngInject */
    constructor($state, $log) {
        this.$state = $state;
        this.$log = $log;
        this.$log.debug('Controller \'GmaoViewHeader\' loaded');
    }

    doCommand(command) {
        if (command.state) {
            this.$state.go(command.state, command.stateParams);
        } else {
            command.handler();
        }
    }
}

export const gmaoViewHeaderComponent = {
    template: require('./gmao-view-header.html'),
    controller: GmaoViewHeaderController,
    bindings: {
        labelKey: '<',
        commands: '<',
        disabled: '<'
    }
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/GmaoViewHeader.js